

import { toast } from 'react-toastify';
import React, { useState, useEffect } from 'react';
// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';

import {
  Button, TextField, InputAdornment, Select, MenuItem, Divider,
  InputLabel, FormControl
} from '@material-ui/core';

import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { roles, sharingValues, colors, toastTimerValue } from '../../../../Shared/utils';
import { create } from '../../../../Functions/admin';
import { useAppContext } from '../../../../Context/App/Provider';
import { useReportingContext } from '../../../../Context/Reporting/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';

import { getTemplates, uploadTemplate, downloadTemplate, getCustomSizes } from '../../../../Functions/admin';
import { apiUrl, config } from '../../../../Shared/config';

import { decodeHTMLEntities } from '../../../../Functions/utils';
import CreatePageSize from './PageSize/CreatePageSize';

import '../../../SweetAlert.css'

export default function CreateReport({ setSelectedReport, setLoadedReport }) {

  const { t } = useTranslation();
  const [{ user, settings }, appDispatch] = useAppContext();
  const [{ pickers }, dispatch] = useReportingContext();

  const [templates, setTemplates] = useState([]);
  const [loaded, setLoaded] = useState(templates && templates.length > 0);

  const [{ reportsStatus }, eventDispatch] = useEventContext();

  const [loading, setLoading] = useState(false);

  const [customSizes, setCustomeSizes] = useState([]);
  const [forceReloadCustomeSizes, setForceReloadCustomeSizes] = useState("~auto~");
  const [addPageSizePanelVisible, setAddPageSizePanelVisible] = useState(false);
  const [defaultTemplate, setDefaultTemplate] = useState(0);

  const [newReport, setNewReport] = useState({
    name: '',
    template: 0,
    format: '',
    language: 'en', //(settings.lang && settings.lang === 'fr' ? 'fr' : 'en'),
    pageSize: 'a4',
    orientation: 'portrait',
    dateFormat: 'YYYYMMDD HHMMSS',
    sharingOptions: user.roleId <= roles.stAdmin ? 1 : 0,
    groups: user.roleId <= roles.stAdmin ? [] : [user.groupId],
    enabled: true
  });


  useEffect(() => {
    // console.log("66 - templates=", templates);
    if (templates.length === 0 && loaded === false) {
      setLoading(true);
      getTemplates().then(res => {
        if (!res.success) {
          toast(decodeHTMLEntities(t('admin.reports.errors.' + res)), { type: 'error' });

          // Swal.fire({
          //   toast: true,
          //   icon: 'error',
          //   title: t('scenarios.errors.' + res),
          //   animation: true,
          //   position: 'top-right',
          //   showConfirmButton: false,
          //   timer: toastTimerValue,
          //   timerProgressBar: true,
          //   iconColor: 'white',
          //   customClass: {
          //     popup: 'colored-toast',
          //   },
          //   didOpen: (toast) => {
          //     toast.addEventListener('mouseenter', Swal.stopTimer)
          //     toast.addEventListener('mouseleave', Swal.resumeTimer)
          //     toast.addEventListener('click', Swal.close)
          //   }
          // });

        } else {
          // console.log("94 - res=", res);
          if (res.templates && defaultTemplate !== '') {
            setNewReport({ ...newReport, template: defaultTemplate })
            setDefaultTemplate('');
          }
          setTemplates(res.templates);
          // console.log("97 - defaultTemplate=", defaultTemplate);
        }
        setLoading(false);
        setLoaded(true);
      });
    }
  }, [loaded, templates, setTemplates, setLoaded]);


  useEffect(() => {
    // console.log("76 - forceReloadCustomeSizes=", forceReloadCustomeSizes);
    if (forceReloadCustomeSizes !== '') {
      getCustomSizes().then(res => {
        // console.log("80 - getCustomSizes=", res);
        if (res.success) {
          setCustomeSizes(res.pageSizes);

          if (forceReloadCustomeSizes !== '~auto~')
            setNewReport({ ...newReport, pageSize: forceReloadCustomeSizes })
        }
      });
      setForceReloadCustomeSizes('');
    }
  }, [forceReloadCustomeSizes]);


  const handleCreateReport = (e, report) => {
    const newReport = {
      ...report
    };

    const regex = /[0-9a-z]+$/i;  // 
    const tmpExt = newReport.outputFileName && newReport.outputFileName.match(regex) && newReport.outputFileName.match(regex)[0];

    if (tmpExt && newReport.format === tmpExt) {
      newReport.outputFileName = newReport.outputFileName.substring(0, newReport.outputFileName.length - 4);
    }
    
    e.preventDefault();
    setLoading(true);

    create({ type: 'report', report: newReport }).then(res => {
      setLoading(false);
      if (!res.success) {
        return toast(decodeHTMLEntities(t('admin.reports.errors.' + res, { name: newReport.name })), { type: 'error' });

        // return Swal.fire({
        //   toast: true,
        //   icon: 'error',
        //   title: t('admin.reports.errors.' + res, { name: newReport.name }),
        //   animation: true,
        //   position: 'top-right',
        //   showConfirmButton: false,
        //   timer: toastTimerValue,
        //   timerProgressBar: true,
        //   iconColor: 'white',
        //   customClass: {
        //     popup: 'colored-toast',
        //   },
        //   didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     toast.addEventListener('click', Swal.close)
        //   }
        // });
      }

      // const newReports = res.report;
      // console.log("83 - res=", res);
      // setReports(newReports.sort((a, b) => a.name.localeCompare(b.name)));
      eventDispatch({ reportsStatus: 'force' });

      setSelectedReport(null);
      toast(decodeHTMLEntities(t('admin.reports.create.success', { name: newReport.name })), { type: 'success' });

      // Swal.fire({
      //   toast: true,
      //   icon: 'success',
      //   title: t('admin.reports.create.success', { name: newReport.name }),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });

      setLoadedReport(false);
    });
  };

  const hiddenFileInput = React.useRef(null);

  const handleChange = async event => {
    // const fileUploaded = event.target.files[0];
    // console.log("89 - event.target=", event.target);

    // console.log("89 - templates=", event.target.files, templates, user);

    let size = 0;
    let primaryFileCount = 0;
    let mainFile = '';
    for (const file of event.target.files) {
      size += file.size;

      const fileExt = file.name.split('.').pop().toLowerCase();
      if (
        fileExt === "html" || fileExt === "xml" || fileExt === "csv"
      ) {
        primaryFileCount++;
        mainFile = file.name;
      }
    }

    if (size > 4194304) {
      toast(decodeHTMLEntities(t('admin.reports.errors.template_size')), { type: 'error' });

      // Swal.fire({
      //   toast: true,
      //   icon: 'error',
      //   title: t('admin.reports.errors.template_size'),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    }
    else if (primaryFileCount !== 1) {
      toast(decodeHTMLEntities(t('admin.reports.errors.template_file')), { type: 'error' });

      // Swal.fire({
      //   toast: true,
      //   icon: 'error',
      //   title: t('admin.reports.errors.template_file'),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    }
    else {

      let alreadyExists = false;
      for (const item of templates) {
        if (item.Name.toLowerCase() === mainFile.toLowerCase()) { // already exists

          alreadyExists = true;
          if (item.Owner === user.id) {   // replace or need to be renamed ?
            // console.log("120 - already exists - same owner", t('admin.reports.confirmUploadTemplate.confirm_same_owner'));

            // if (window.confirm(t('admin.reports.confirmUploadTemplate.confirm_same_owner', { name: mainFile }))) {

            // Swal({
            //   title: t('global.dialog_title'),
            //   text: t('admin.reports.confirmUploadTemplate.confirm_same_owner', { name: mainFile }),
            //   // icon: "warning",
            //   buttons: {
            //     confirm: {
            //       text: t("global.yes"),
            //       value: true,
            //       visible: true,
            //       className: "btnPrimary",
            //       closeModal: true
            //     },
            //     cancel: {
            //       text: t("global.no"),
            //       value: false,
            //       visible: true,
            //       className: "btnSecondary",
            //       closeModal: true,
            //     }
            //   },
            //   closeOnClickOutside: false
            // }).then((value) => {


            //   if (value) {

            //     const filesToUpload = new Array();
            //     for (const file of event.target.files) {

            //       // console.log("100 - file=", file.size);

            //       const reader = new FileReader();
            //       reader.readAsDataURL(file);

            //       reader.onload = function () {
            //         // console.log("98 - onload=", reader);

            //         const base64String = reader.result
            //           .replace('data:', '')
            //           .replace(/^.+,/, '');

            //         const fileData = {
            //           lastModified: file.lastModified,
            //           name: file.name,
            //           size: file.size,
            //           type: file.type,
            //           webkitRelativePath: file.webkitRelativePath,
            //           data: base64String
            //         }
            //         filesToUpload.push(fileData);

            //         if (filesToUpload.length === event.target.files.length) {

            //           // console.log("119 - filesToUpload=", filesToUpload);
            //           uploadTemplate(filesToUpload);

            //           setTimeout(() => {
            //             setTemplates([]);
            //             setLoaded(false);
            //           }, 1000);
            //         }
            //       };
            //       reader.onerror = function () {
            //         console.log("101 - onerror=", reader.error);
            //       };
            //     }
            //   }
            // });

            Swal.fire({
              allowOutsideClick: false,
              title: t('global.dialog_title'),
              html: t('admin.reports.confirmUploadTemplate.confirm_same_owner', { name: mainFile }),
              showCancelButton: true,
              confirmButtonText: t("global.yes"),
              cancelButtonText: t("global.no"),
              customClass: {
                confirmButton: 'confirm-button-class',
                title: 'title-class',
                icon: 'icon-class'
                }
            }).then((value) => {

              // console.log("251 - value=", value);
              if (value && value.isConfirmed) {

                setLoading(true);

              const filesToUpload = new Array();
                let mainFile = '';

              for (const file of event.target.files) {

                // console.log("100 - file=", file.size);

                const reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = function () {
                  // console.log("98 - onload=", reader);

                  const base64String = reader.result
                    .replace('data:', '')
                    .replace(/^.+,/, '');

                  const fileData = {
                    lastModified: file.lastModified,
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    webkitRelativePath: file.webkitRelativePath,
                    data: base64String
                  }
                  filesToUpload.push(fileData);

                  if (filesToUpload.length === event.target.files.length) {
                      // console.log("397 - filesToUpload=", filesToUpload);
                      uploadTemplate(filesToUpload).then(res => {

                        // console.log("418 - setTimeout 1000=", res);
                        if (res && res.uploaded && res.uploaded.template && res.uploaded.template[0]) {
                          // console.log("420 - setDefaultTemplate=", res.uploaded.template[0].Id);
                          setDefaultTemplate(res.uploaded.template[0].Id);
                        }
                      setTemplates([]);
                      setLoaded(false);
                      });
                  }
                };
                reader.onerror = function () {
                    // console.log("101 - onerror=", reader.error);
                    setLoading(false);
                };
              }
            }
            });
          }
          else {    // need to be renamed ?
            // console.log("123 - already exists - other owner");
            // window.alert(t('admin.reports.confirmUploadTemplate.confirm_not_same_owner', { name: mainFile }));

            // Swal({
            //   title: t('global.dialog_title'),
            //   text: t('admin.reports.confirmUploadTemplate.confirm_not_same_owner', { name: mainFile }),
            //   // icon: "warning",
            //   buttons: {
            //     ok: {
            //       text: t("global.ok"),
            //       value: true,
            //       visible: true,
            //       className: "btnPrimary",
            //       closeModal: true
            //     }
            //   },
            //   closeOnClickOutside: true
            // });

            Swal.fire({
              allowOutsideClick: false,
              title: t('global.dialog_title'),
              html: t('admin.reports.confirmUploadTemplate.confirm_not_same_owner', { name: mainFile }),
              showCancelButton: false,
              confirmButtonText: t("global.ok"),
              customClass: {
                confirmButton: 'confirm-button-class',
                title: 'title-class',
                icon: 'icon-class'
                }
            });
          }
        }
      }

      if (!!!alreadyExists) {
        setLoading(true);

        const filesToUpload = new Array();
        let mainFile = '';

        for (const file of event.target.files) {
          // console.log("179 - file=", file.size);

          const reader = new FileReader();
          reader.readAsDataURL(file);

          reader.onload = function () {
            // console.log("185 - onload=", reader);

            const base64String = reader.result
              .replace('data:', '')
              .replace(/^.+,/, '');

            const fileData = {
              lastModified: file.lastModified,
              name: file.name,
              size: file.size,
              type: file.type,
              webkitRelativePath: file.webkitRelativePath,
              data: base64String
            }
            filesToUpload.push(fileData);

            if (filesToUpload.length === event.target.files.length) {

              // console.log("504 - uploadTemplate=", filesToUpload);
              uploadTemplate(filesToUpload).then(res => {

                // console.log("504 - setTimeout 1000=", res);
                if (res && res.uploaded && res.uploaded.template && res.uploaded.template[0]) {
                  // console.log("512 - setDefaultTemplate=", res.uploaded.template[0].Id);
                  setDefaultTemplate(res.uploaded.template[0].Id);
                }
                setTemplates([]);
                setLoaded(false);
              });
            }
          };
          reader.onerror = function () {
            // console.log("213 - onerror=", reader.error);
            setLoading(false);
          };
        }
      }
    }
  };

  const handleDownloadTemplate = () => {

    downloadTemplate(newReport.template,).then(res => {

      if (!res || !res.success) {
        toast(decodeHTMLEntities(t('admin.reports.errors.' + res)), { type: 'error' });

        // Swal.fire({
        //   toast: true,
        //   icon: 'error',
        //   title: t('admin.reports.errors.' + res),
        //   animation: true,
        //   position: 'top-right',
        //   showConfirmButton: false,
        //   timer: toastTimerValue,
        //   timerProgressBar: true,
        //   iconColor: 'white',
        //   customClass: {
        //     popup: 'colored-toast',
        //   },
        //   didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     toast.addEventListener('click', Swal.close)
        //   }
        // });
      }
      else {
        let str = res.result[0].data.data;
        var byteArray = new Uint8Array(str.length);
        for (var x = 0; x < byteArray.length; x++) {
          byteArray[x] = str[x];
        }
        var data = new Blob([byteArray]); //, {type: "application/octet-stream"});
        var url = window.URL.createObjectURL(data);

        var link = document.createElement('a');
        link.type = "data:text/plain"
        link.download = res.result[0].filename;
        link.target = "_blank"
        link.href = url;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };


  let ext = '';
  templates.map((template, key) => {
    if (template.Id === newReport.template) {
      newReport.template = template.Id;
      ext = template.Name && template.Name.split('.').pop().toUpperCase();

      if (ext === "XML" || ext === "CSV") {
        newReport.format = ext;
      }
    }
  });



  // console.log("588 - newReport=", newReport, templates, ext);
  // console.log("610 - newReport.template=", newReport.template);

  if (addPageSizePanelVisible) {
    return (
      <CreatePageSize
        setAddPageSizePanelVisible={setAddPageSizePanelVisible}
        setForceReloadCustomeSizes={setForceReloadCustomeSizes}
      />
    )
  }


  return (
    <Prompt animated>
      <form className="prompt__container animated" style={{maxWidth: '720px'}} onSubmit={e => handleCreateReport(e, newReport)}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('admin.reports.create.title')}</h1>
          </div>

          <div className="prompt__content">

            <div className="flexRow">
              <div style={{ width: '100%' }}>
                <TextField
                  InputProps={{
                    startAdornment: <InputAdornment position="start">
                      <span className="material-icons-outlined">assignment</span>
                    </InputAdornment>
                  }}
                  required
                  variant="outlined"
                  style={{ width: '100%' }}
                  value={newReport.name}
                  label={t('admin.reports.columns.name')}
                  onChange={e => setNewReport({ ...newReport, name: e.target.value })}
                />
              </div>
            </div>

            <div>
              <input
                type="file"
                ref={hiddenFileInput}
                style={{ display: 'none' }}
                onChange={handleChange}
                accept=".html, .xml, .csv, .jpg, .png"
                multiple
              />
            </div>

            <div className="flexRow">
              <div style={{ width: '61%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }} required>
                  <InputLabel>{t('admin.reports.columns.template')}</InputLabel>
                  <Select
                    id="select001"
                    label={t('admin.reports.columns.template')}
                    value={newReport.template}
                    onChange={e => {
                      if (e.target.value > 0) {
                        // console.log("170 - newReport=", newReport.template);
                        setNewReport({ ...newReport, template: e.target.value })
                      }
                    }}

                    style={{
                      opacity: (loading) ? '0.4' : '1',
                      cursor: (loading) ? 'not-allowed' : 'pointer'
                    }}

                    disabled={loading}
                  >

                    <div className="container__title"
                      //style={{ color: colors.softthinks }}
                      style={{
                        color: colors.softthinks,
                        opacity: (user.email.includes('DEMO_USER_$')) ? '0.4' : '1',
                        cursor: (user.email.includes('DEMO_USER_$')) ? 'not-allowed' : 'pointer'
                      }}
                      onClick={e => {
                        if (user.email.includes('DEMO_USER_$') === false) {
                        setNewReport({ ...newReport, template: 0 })
                        hiddenFileInput.current.click();
                        }
                      }}
                    >
                      <span className="material-icons">upload_file</span>
                      <span> {t('admin.reports.uploadTemplate')}</span>
                    </div>

                    {templates.length > 0 ? (
                      <div>
                        <Divider />
                      </div>
                    ) : (
                      <div>
                      </div>
                    )}

                    {templates.length > 0 ? (
                      templates.sort(function (a, b) {
                        if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
                          return -1;
                        }
                        if (b.Name.toLowerCase() < a.Name.toLowerCase()) {
                          return 1;
                        }
                        return 0;
                      }).map((template, key) => (
                        <MenuItem
                          value={template.Id}
                          name={template.Name}
                        >
                          {template.Name}
                        </MenuItem >
                      ))

                    ) : (
                      <div>
                      </div>
                    )}

                  </Select>
                </FormControl>
              </div>

              <Button
                title={t('admin.reports.downloadTemplate')}
                className="button"
                disabled={!newReport.template}
                color={colors.softthinks}
                style={{ width: '5%', /*height: '100%',*/ marginLeft: '-13px' }}
                onClick={(e) => handleDownloadTemplate(e)}
              >
                <span className="material-icons">download</span>
              </Button>

              <div style={{ width: '33%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }} required>
                  <InputLabel>{t('admin.reports.columns.format')}</InputLabel>
                  <Select
                    disabled={!newReport.template}
                    label={t('admin.reports.columns.format')}
                    value={newReport.format}
                    onChange={e => setNewReport({ ...newReport, format: e.target.value })}
                  >
                    {ext === "XML" && (
                      <MenuItem value={'XML'}>XML</MenuItem>
                    )}

                    {ext === "CSV" && (
                      <MenuItem value={'CSV'}>CSV</MenuItem>
                    )}

                    {ext === "HTML" && (
                      <MenuItem value={'HTML'}>HTML</MenuItem>
                    )}
                    {ext === "HTML" && (
                      <MenuItem value={'PDF'}>PDF</MenuItem>
                    )}

                  </Select>
                </FormControl>
              </div>
            </div>

            <div className="flexRow">
              <div style={{ width: newReport.format === "PDF" ? '20%' : '50%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.reports.columns.language')}</InputLabel>
                  <Select
                    label={t('admin.reports.columns.language')}
                    value={newReport.language}
                    onChange={e => setNewReport({ ...newReport, language: e.target.value })}
                  >
                    <MenuItem value={'en'}>{t('admin.reports.language.english')}</MenuItem>
                    <MenuItem value={'fr'}>{t('admin.reports.language.french')}</MenuItem>
                    {/* <MenuItem value={'es'}>{t('admin.reports.language.spanish')}</MenuItem> */}
                    <MenuItem value={'nl'}>{t('admin.reports.language.dutch')}</MenuItem>
                  </Select>
                </FormControl>
              </div>

              {newReport.format === "PDF" && (
                <div style={{ width: '25%' }}>
                  <FormControl variant="outlined" style={{ width: '100%' }}>
                    <InputLabel>{t('admin.reports.columns.pageSize')}</InputLabel>
                    <Select
                      label={t('admin.reports.columns.pageSize')}
                      value={newReport.pageSize}
                      onChange={e => {
                        // console.log("602 - setNewReport pageSize=", e.target.value);
                        if (e.target.value !== undefined)
                          setNewReport({ ...newReport, pageSize: e.target.value })
                      }}
                    >                      
                      <div className="container__title"
                        style={{ color: colors.softthinks }}
                        onClick={e => {
                          setAddPageSizePanelVisible(true);
                        }}
                    >
                        <span className="material-icons">add_circle_outline</span>
                        <span> {t('admin.reports.addCustomPageSize')}</span>
                      </div>

                      <div>
                        <Divider />
                      </div>

                      <MenuItem value={'letter'}>Letter</MenuItem>
                      <MenuItem value={'a4'}>A4</MenuItem>
                      {/* <MenuItem value={'a0'}>A0</MenuItem>
                      <MenuItem value={'a1'}>A1</MenuItem>
                      <MenuItem value={'a2'}>A2</MenuItem> */}
                      <MenuItem value={'a3'}>A3</MenuItem>
                      <MenuItem value={'a5'}>A5</MenuItem>
                      {/* <MenuItem value={'a6'}>A6</MenuItem>
                      <MenuItem value={'a7'}>A7</MenuItem>
                      <MenuItem value={'a8'}>A8</MenuItem>
                      <MenuItem value={'a9'}>A9</MenuItem> */}
                      {/* <MenuItem value={'b0'}>B0</MenuItem>
                      <MenuItem value={'b1'}>B1</MenuItem>
                      <MenuItem value={'b2'}>B2</MenuItem>
                      <MenuItem value={'b3'}>B3</MenuItem>
                      <MenuItem value={'b4'}>B4</MenuItem>
                      <MenuItem value={'b5'}>B5</MenuItem>
                      <MenuItem value={'b6'}>B6</MenuItem>
                      <MenuItem value={'b7'}>B7</MenuItem>
                      <MenuItem value={'b8'}>B8</MenuItem>
                      <MenuItem value={'b9'}>B9</MenuItem>
                      <MenuItem value={'b10'}>B10</MenuItem> */}
                      <MenuItem value={'c5e'}>C5E</MenuItem>
                      <MenuItem value={'comm10e'}>Comm10E</MenuItem>
                      <MenuItem value={'dle'}>DLE</MenuItem>
                      <MenuItem value={'executive'}>Executive</MenuItem>
                      <MenuItem value={'folio'}>Folio</MenuItem>
                      <MenuItem value={'ledger'}>Ledger</MenuItem>
                      <MenuItem value={'legal'}>Legal</MenuItem>
                      <MenuItem value={'tabloid'}>Tabloid</MenuItem>

                      {customSizes && customSizes.length > 0 ? (
                        <div>
                          <Divider />
                        </div>
                      ) : (
                        <div>
                        </div>
                      )}

                      {customSizes && customSizes.length > 0 ? (
                        customSizes.sort(function (a, b) {
                          if (a.size.toLowerCase() < b.size.toLowerCase()) {
                            return -1;
                          }
                          if (b.size.toLowerCase() < a.size.toLowerCase()) {
                            return 1;
                          }
                          return 0;
                        }).map((customSize, key) => (
                          <MenuItem
                            value={customSize.size}
                          >
                            {customSize.size}
                          </MenuItem>
                        ))

                      ) : (
                        <div>
                        </div>
                      )}

                    </Select>
                  </FormControl>
                </div>
              )}

              {newReport.format === "PDF" && (
                <div style={{ width: '25%' }}>
                  <FormControl variant="outlined" style={{ width: '100%' }}>
                    <InputLabel>{t('settings.export.orientation')}</InputLabel>
                    <Select
                      label={t('settings.export.orientation')} value={newReport.orientation}
                      onChange={e => setNewReport({ ...newReport, orientation: e.target.value })}
                    >
                      <MenuItem value={'portrait'}>{t('settings.export.portrait')}</MenuItem>
                      <MenuItem value={'landscape'}>{t('settings.export.landscape')}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              )}


              <div style={{ width: newReport.format === "PDF" ? '35%' : '50%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.reports.columns.dateFormat')}</InputLabel>
                  <Select
                    label={t('admin.reports.columns.dateFormat')}
                    value={newReport.dateFormat}
                    onChange={e => setNewReport({ ...newReport, dateFormat: e.target.value })}
                  >
                    <MenuItem value={'YYYYMMDD HHMMSS'}>YYYYMMDD HHMMSS</MenuItem>
                    <MenuItem value={'MMDDYYYY HHMMSS'}>MMDDYYYY HHMMSS</MenuItem>
                    <MenuItem value={'DDMMYYYY HHMMSS'}>DDMMYYYY HHMMSS</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className="flexRow">
              <div style={{ width: '100%' }}>
                <TextField
                  InputProps={{
                    startAdornment: <InputAdornment position="start">
                      <span className="material-icons-outlined">insert_drive_file</span>
                    </InputAdornment>
                  }}
                  variant="outlined"
                  style={{ width: '100%' }}
                  value={newReport.outputFileName}
                  label={t('admin.reports.columns.outputFileName')}
                  onChange={e => {
                    return setNewReport({ ...newReport, outputFileName: e.target.value })
                  }}
                />
              </div>
            </div>

            <div className="flexRow">
            </div>

            <div className="flexRow">
              <div style={{ width: '100%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.reports.columns.sharingOptions')}</InputLabel>

                  {user.roleId <= roles.stAdmin && (
                    <Select
                      label={t('admin.reports.columns.sharingOptions')}
                      value={newReport.sharingOptions}
                      onChange={e => {
                        const sharingOptions = Number(e.target.value);
                        if (
                          sharingOptions === sharingValues.noOne ||
                          sharingOptions === sharingValues.everyone ||
                          sharingOptions === sharingValues.allStAdmins
                        ) {

                          setNewReport({
                            ...newReport,
                            sharingOptions: sharingOptions,
                            groups: [],
                            locations: []
                          });
                        }
                        else {
                          setNewReport({ ...newReport, sharingOptions: sharingOptions })
                        }
                      }}

                    //setNewReport({ ...newReport, sharingOptions: Number(e.target.value) })}
                    >
                      <MenuItem value={sharingValues.noOne}>{t('scenarios.no_one')}</MenuItem>
                      <MenuItem value={sharingValues.everyone}>{t('scenarios.everyone')}</MenuItem>
                      <MenuItem value={sharingValues.allStAdmins}>{t('scenarios.allStAdmins')}</MenuItem>
                      <MenuItem value={sharingValues.allGroupAdmins}>{t('scenarios.allGroupAdmins')}</MenuItem>
                      <MenuItem value={sharingValues.allGroupUsers}>{t('scenarios.allGroupUsers')}</MenuItem>
                    </Select>
                  )}

                  {user.roleId === roles.admin && (
                    <Select
                      label={t('admin.reports.columns.sharingOptions')}
                      value={newReport.sharingOptions}
                      onChange={e => setNewReport({ ...newReport, sharingOptions: Number(e.target.value) })}
                    >
                      <MenuItem value={sharingValues.noOne}>{t('scenarios.no_one')}</MenuItem>
                      {user.email.includes('DEMO_USER_$') == false && <MenuItem value={sharingValues.allGroupAdmins}>{t('scenarios.allGroupAdmins')}</MenuItem>}
                      {user.email.includes('DEMO_USER_$') == false && <MenuItem value={sharingValues.allGroupUsers}>{t('scenarios.allGroupUsers')}</MenuItem>}
                    </Select>
                  )}
                </FormControl>


                {user.roleId <= roles.stAdmin && (

                  <div className="checkbox action">
                    <input
                      disabled={newReport.sharingOptions === sharingValues.noOne || newReport.sharingOptions === sharingValues.everyone}
                      id="allowModifications"
                      type="checkbox"
                      defaultChecked={newReport.allowModifications}
                      onChange={e => {
                        setNewReport({ ...newReport, allowModifications: !newReport.allowModifications })
                      }}
                    />
                    <label htmlFor="allowModifications">{t('admin.reports.allowModifications')}</label>
                  </div>
                )}

                {user.roleId === roles.admin && (
                  <div className="checkbox action">
                    <input
                      disabled={newReport.sharingOptions === sharingValues.noOne || newReport.sharingOptions === sharingValues.everyone}
                      id="allowModifications"
                      type="checkbox"
                      defaultChecked={newReport.allowModifications}
                      onChange={e => {
                        setNewReport({ ...newReport, allowModifications: !newReport.allowModifications })
                      }}
                    />
                    <label htmlFor="allowModifications">{t('admin.reports.allowModifications')}</label>
                  </div>
                )}
              </div>
            </div>

            {user.roleId <= roles.stAdmin && (
              <div >
                {(newReport.sharingOptions !== sharingValues.everyone && newReport.sharingOptions !== sharingValues.noOne && newReport.sharingOptions !== sharingValues.allStAdmins) && (
                  <div className="sidebar__select" style={{ padding: 0 }}>
              <div className="flexRow">
                <div style={{ width: '100%' }}>
                  <FormControl variant="outlined" style={{ width: '100%' }}>
                    <InputLabel>{t('admin.reports.columns.group')}</InputLabel>
                    <Select
                      onChange={e => setNewReport({
                        ...newReport,
                        groups: [Number(e.target.value)]
                      })}
                      value={newReport.groups[0] ?? '0'}
                      label={t('admin.reports.columns.group')}
                    >
                      {/* <option value="0" hidden>{multiSelectStrings(t, 'grp', newReport).selectSomeItems}</option> */}
                      {pickers.groups.map(group => <MenuItem key={group.value} value={group.value}>{group.label}</MenuItem>)}
                    </Select>
                  </FormControl>
                </div>
              </div>
                  </div>
                )}
              </div>
            )}

          </div>
        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => setSelectedReport(null)}>
            {t('global.cancel')}
          </Button>

          <Button 
            className="btnPrimary" 
            type="submit" 
            // disabled={loading || !loaded}
            disabled={loading || newReport.label === "" || (newReport.groups.length === 0 &&
              user.roleId <= roles.stAdmin && newReport.sharingOptions !== sharingValues.everyone && newReport.sharingOptions !== sharingValues.noOne && newReport.sharingOptions !== sharingValues.allStAdmins
            )}
          >
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)" /> : t('global.create')}
          </Button>
        </PromptActions>
      </form>
    </Prompt>
  );
}
